import {
  Component,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Router, ActivatedRoute } from '@angular/router';
import { CacheService } from 'app/infrastructure/services/cache.service';
import {
  DesignerCachableOutput,
  DesignerContextType
} from '../../types/designer-context-type';
import { CompleteDesignerContext } from '../main/completeContext';
import { SxInternalStateDesignerService } from '../../services/internal-state-designer-service';

@Component({
  selector: 'sx-rule-modal',
  templateUrl: './rule-modal.component.html'
})
export class SxRuleModalComponent {

  // Designer Context
  @Input()
  designerContext: DesignerContextType;
  // Application Context
  @Input()
  completeContext: CompleteDesignerContext;

  @Output()
  saveDesigner: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private ngxSmartModalService: NgxSmartModalService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cacheService: CacheService,
    private internalState: SxInternalStateDesignerService
  ) {}

  // this is triggered to create a new interaction rule if needed
  createNewInteractionRule() {
    // saves the configuration first
    this.saveDesigner.emit(false);

    // only remembers the last step
    this.cacheService.removeDesignerOutputs();
    const contx: DesignerCachableOutput = {
      storedContext: this.completeContext,
      storedSelectionId: this.designerContext.selectedDesigner.id,
      propertyName: this.internalState.getCurrentPropertyModal()
    };
    this.cacheService.setDesignerOutputs(contx);
    // closes the modal
    this.ngxSmartModalService.getModal('goToNewRuleModal').close();

    // navigates acording to the list path
    if (this.designerContext.attrubuteList) {
      this.router.navigate(
        ['../../../', 'interactionEvent', 'InteractionEvent', 'NewRule'],
        { relativeTo: this.activatedRoute }
      );
    } else {
      this.router.navigate(
        ['../../', 'interactionEvent', 'InteractionEvent', 'NewRule'],
        { relativeTo: this.activatedRoute }
      );
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/rule-modal.component.ts